<style scoped lang="scss" xmlns="http://www.w3.org/1999/html">
.shop_settlement_rules_page {
    padding-left: 15px;
    padding-right: 15px;

    &.active {
        padding-top: 64px;
        padding-top: calc(64px + constant(safe-area-inset-bottom)); /* 兼容 iOS < 11.2 */
        padding-top: calc(64px + env(safe-area-inset-bottom)); /* 兼容 iOS >= 11.2 */
    }

    .header {
        box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.15);
    }
}

.agreement-box {
    padding-bottom: 30px;
    font-size: 13px;
    font-weight: 400;
    color: rgba(66, 66, 66, 1);
}

.title {
    padding: 20px 0 10px 0;
    width: 100%;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    color: rgba(66, 66, 66, 1);
}

.txt-indent {
    text-indent: 2em;
}

.bold {
    font-weight: bold;
}

.pl10 {
    padding-left: 10px;
}

.pt10 {
    padding-top: 10px;
}

.pt20 {
    padding-top: 20px;
}

.unl {
    text-decoration: underline;
}

.f14 {
    font-size: 14px;
}

.f15 {
    font-size: 15px;
}

.justify {
    text-align: justify
}

p {
    //width: 343px;
    font-size: 13px;
    font-weight: 400;
    color: rgba(66, 66, 66, 1);
    line-height: 18px;
    text-align: justify;
    text-indent: 2em;
}
</style>

<template>
    <div class="shop_settlement_rules_page" :class="{'active': type === 'H5'}">
        <header-bar v-if="type === 'H5'" class="header" title="隐私政策" @back="handleBack"/>

        <div class="agreement-box">
            <div class="title">剑琅联盟隐私政策</div>
            <p class="txt-indent">
              剑琅联盟（以下或称“我们”）非常注重保护用户（“您”）的个人信息及隐私，我们深知个人信息对您的重要性，并将按照《中华人民共和国网络安全法》、《中华人民共和国个人信息保护法》、《中华人民共和国民法典》、《信息安全技术个人信息安全规范》以及其他法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。我们希望通过本隐私政策向您清晰地介绍在使用我们的产品与/或服务时，我们如何处理您的个人信息，以及我们为您提供的访问、更正、删除和保护这些信息的方式。</p>
            <p class="txt-indentx">本政策与您所使用的我们的产品与/或服务息息相关，您在下载、安装、启动、浏览、注册、登录、使用我们的产品与/或服务（以下统称“使用我们的产品与/或服务”）时，我们将按照本政策的约定处理和保护您的个人信息。我们尽量以简明扼要的表述向您解释本政策所涉及的技术词汇，以便于您理解。
              <span class="bold f14">本政策中与您权益（可能）存在重大关系的条款，我们已使用加粗字体予以区别，请您重点查阅。</span></p>
            <p class="txt-indentx pt10"> <span class="bold f14">
              剑琅联盟特别提请未满18周岁的未成年人（特别是未满十四周岁的儿童）及其监护人的注意，我们已明确未成年保护专门章节（以粗体提示），请您仔细阅读。
            </span></p>
            <div class="pt10 bold">
                <div class="bold">本政策将帮助您了解以下内容：</div>
                <div>一.在剑琅联盟，您的个人数据是指什么；</div>
                <div>二.我们如何收集和使用您的个人信息；</div>
                <div>三.我们如何使用Cookie和同类技术；</div>
                <div>四.我们如何共享、转让、公开披露您的个人信息；</div>
                <div>五.我们如何保存和保护您的个人信息；</div>
                <div>六.您如何管理您的个人信息；</div>
                <div>七.未成年人的个人信息保护；</div>
                <div>八.通知和修订；</div>
                <div>九.如何联系我们</div>
                <div>十.其他；</div>
                <div>十一.附录。</div>
            </div>
            <div class="pt20 bold">
                <div>【 特别提示 】</div>
                <p class="bold txt-indent">
                    请您在使用我们提供的各项产品与 / 或服务前，仔细阅读并充分理解本《隐私政策》并作出相应选择。一旦您使用或继续使用我们的产品与/或服务时，即意味着您同意我们按照本隐私政策处理您的相关信息。（如对本隐私政策有任何疑问，您可以通过本隐私政策“如何联系我们”中提供的方式与我们联系） 。</p>
            </div>
            <p class="pt20 bold txt-indent">剑琅联盟所有的产品与/或服务（包括剑琅联盟提供的产品与/或服务及未设独立隐私政策的剑琅联盟关联方提供的产品与/或服务）均适用本隐私政策。</p>
            <p class="pt10 bold txt-indent">剑琅联盟的产品与/或服务是由上海市集勇信息科技有限公司（注册地址：上海市黄浦区淮海中路222号13楼）及其关联方提供者向您提供的产品与/或服务。</p>
            <p class="pt20 bold txt-indent">
                本政策不适用于您通过我们的产品与/或服务而接入的其他第三方产品与/或服务（“其他第三方”，包括但不限于您的交易相对方、任何第三方网站以及第三方服务提供者），具体规定请参照该第三方的隐私政策或类似声明。</p>
            <div class="pt20">
                <div class="bold">一．在剑琅联盟，您的个人数据是指什么？</div>
                <p class="pt10">在剑琅联盟，我们坚信并尊重基本隐私权，<span class="bold">我们将任何与已识别或可识别的个⼈相关的数据或剑琅联盟已与个⼈或可与之关联的数据视为“个⼈数据”，⽽⽆论相关个⼈所居何处。</span>这意味着，可⽤来直接识别你身份的数据 (如你的姓名) 属于个⼈数据，另外，不能⽤来直接识别你的身份但可通过合理推断间接识别你身份的数据 也是个⼈数据。就本隐私政策⽽⾔，汇总数据被视为⾮个⼈数据。</p>
            </div>
            <div class="pt20 bold">二、我们如何收集和使用您的个人信息</div>
            <p class="pt10">您理解并同意：</p>
            <p>我们将在本政策中依次向您说明每项功能可能收集的个人信息范围、收集目的、收集方式，以及拒绝提供个人信息可能导致的结果。请您知悉，您拒绝提供各项功能实现所必要的对应信息时，仍然可以使用剑琅联盟的其他功能。</p>
          <p class="pt10">在您使用剑琅联盟产品与/或服务的过程中，我们访问您的各项权限是为了向您提供服务，优化我们的服务以及保障您的账号安全，我们会出于本政策的所述目的，收集和使用您的个人信息。您<span class="bold">需要/可以选择授权</span>我们收集和使用个人信息的场景包括：</p>
            <p class="pt10">1、为了向您提供我们产品与/或服务的基本功能，您<span class="bold">需要授权</span>与/或服务；</p>
            <p class="pt10">2、为了向您提供我们产品与/或服务的拓展功能，您<span class="bold">可以选择授权</span>我们收集、使用信息的情形，如您拒绝提供前述信息，您将无法正常使用相关附加功能或无法实现我们拟达到的功能效果，但并不会影响您正常使用我们产品与/或服务的基本功能。</p>
            <div class="pt20 bold">一.您需要授权我们收集和使用个人信息的场景</div>
            <p class="pt10">我们会遵循正当、合法、必要的原则，出于本政策所述的下列目的收集和使用您的个人信息。</p>
            <p class="pt10 bold">1.帮助您成为我们的用户</p>
            <p class="pt10">为遵守法律法规的要求，以及向您提供更个性化、更便捷的服务，在您注册成为剑琅联盟用户时，您需要至少提供手机号码以创建剑琅联盟账号，并完善相关的网络身份识别信息（如头像、昵称及登录密码等）；如果您仅需使用浏览、搜索等功能，您无需注册成为我们的用户以及提供上述信息。当您登录时，如您使用一键登录的功能，基于我们与通信运营商的合作，我们会收集您的【手机号码和手机运营商信息】，以便为您提供快捷的登录服务。</p>
          <p class="pt10 bold">在提供账号信息的过程中，如果您愿意额外补充如下个人信息，将有助于我们向您提供更为个性化的服务：包括您的性别、生日、常居地、家乡、喜好、家庭信息等。如果您不提供该等信息，不会影响您享受剑琅联盟服务的基本功能。</p>
           <p class="pt10 bold">如您选择授权使用第三方账号登录时，我们会从第三方获取您共享的账号信息（如头像、昵称、地区、性别等信息）与您的剑琅联盟账号进行绑定用于快捷登录，我们会依据与第三方的约定，在符合相关法规的前提下，使用您的个人信息。</p>
            <p class="pt10 bold">2.向您提供基于地理位置的信息展示</p>
            <p class="pt10">为了向您提供周边吃喝玩乐及出行信息的展示和搜索服务，提升我们的服务表现、效率和功能，经您授权我们会收集您在使用我们服务过程中产生的相关信息，包括：</p>
            <div>
              <p><span class="bold">(1）位置信息</span>。<span class="bold">当您通过系统授权开启移动设备的定位功能并使用基于位置提供的服务时，我们会收集和使用您的位置信息以便为您推荐周边的生活服务</span>（例如您不需要手动输入所在地理位置就可获得相关服务，估算商家与您之间的实际距离方便您进行消费决策，为您推荐附近的服务品类和优惠信息等）。我们会使用有关技术获取您的 <span class="bold">位置信息</span>（准确度会有所不同），这些技术包括 IP 地址、GPS 以及能够提供相关信息的WLAN（如Wi-Fi） 接入点、蓝牙和基站等。<span class="bold">您使用服务中提供的信息中可能包含相应地理位置信息，例如您在账号资料中设置的地区信息或您上传的图片、视频中的地理标记信息。您可以在移动设备的系统中关闭定位服务停止我们对您所在位置信息的收集，但可能因此无法使用我们基于地理位置为您提供的服务，或者无法达到相关服务的预期效果。</span>
                </p>
                <p><span class="bold">(2）日志信息</span>。当您使用我们提供的产品与/或服务时，我们会收集您的浏览、搜索、点击、收藏、添加购物车、交易、售后、关注、分享、发布等信息并作为有关网络日志进行保存，其中包括您的IP地址、浏览器的类型、使用的语言、操作系统的版本、访问的日期和时间、电信运营商、网络请求等。
                </p>
                  <p><span class="bold">3 为您提供信息浏览、发布、点赞、收藏、分享功能</span></p>
              <p>为了向您提供我们最核心的信息展示服务并向您推荐可能感兴趣的笔记及相关信息，我们会收集您的性别、生日、浏览记录（您的关注、浏览）和点击操作记录（兴趣、点击、搜索、点赞、收藏、分享、评论、发布记录及有关行为）。若您希望关闭我们基于有关信息向您进行的推荐，您可以在设置中进行关闭。</p>
              <p class="pt10">当您使用发布、编辑笔记、图片、音视频功能时，我们会请求您授权照片、相机、麦克风权限。您如果拒绝授权提供，将无法使用相应功能，但不影响您正常使用剑琅联盟的其他功能。</p>
                <p class="pt10">当您使用发布、评论、点赞、收藏、分享功能时，您发布的文字、照片、视频、音频、评论、点赞、收藏、分享记录信息会存储在我们的服务器中，因为存储是实现这一功能所必需的。我们会以加密的方式存储，您也可以随时删除这些信息。</p>
                <p><span class="pt10 bold">4 为您提供预订、下单、订单管理功能</span></p>
                <p>您在剑琅联盟上预订/下单服务时，您需要根据所选择的服务类型提供<span class="bold">联系人信息（姓名、电话号码等）、地址信息</span>、 服务偏好等。</p>
                <p class="pt10">为向您展示您账号的订单信息及便于您对订单信息的管理，我们会收集您在使用我们服务过程中产生的订单信息。</p>
                <p class="pt10"><span class="bold">您在剑琅联盟上生成的订单中，将可能包含您的身份信息、联络信息、行程信息、 住宿信息、支付信息等，这些都属于敏感信息，请您谨慎向他人展示或对外提供，</span>我们也将会在展示订单信息时，在保证信息可用性的基础上尽量去标识化处理。</p>
                <p><span class="pt10 bold">5 为您提供支付服务，帮助您完成支付</span></p>
              <p>当您使用剑琅联盟上提供的支付服务时，<span class="bold">我们还可能会收集您的身份证件信息（含影印件）、银行卡信息等，</span>您在剑琅联盟上进行订单支付时，您可以选择剑琅联盟及其关联方或者剑琅联盟的第三方合作机构（如支付宝、微信支付、QQ 钱包、Apple Pay等合作方）所提供的服务进行支付。我们需要收集您的剑琅联盟订单信息、对账信息及其他法律要求的必要信息并与这些合作机构共享，以确认您的支付指令并帮助您完成支付。</p>
                <p><span class="pt10 bold">6 为您提供客服和售后服务</span></p>
                <p >当您与我们的客服取得联系时，我们的系统可能会记录您与客服之间的通讯记录，以及使用您的账号信息以便核验身份；当您需要我们提供与您订单相关的客户服务时，我们可能会查询您的相关订单信息以便给予您适当的帮助和处理；当您需要客服协助您修改有关信息（如联系方式等）时，您可能还需要提供上述信息外的其他信息以便完成修改。</p>
                <p><span class="pt10 bold">7 为您提供安全保障</span></p>
              <p>为了保障您的账号安全以及系统运行安全，满足法律法规和我们协议规则的相关要求，在您使用我们的产品与/或服务过程中，经您授权我们会获取您的设备信息，<span class="bold">包括您使用的设备属性、连接和状态信息，例如设备型号、设备标识符（如IMEI/androidID/IDFA/OPENUDID/GUID/OAID、SIM卡IMSI、ICCID信息等）、设备MAC地址、软件列表、电信运营商等软硬件特征信息。</span></p>
                <p class="pt10">为提高您使用我们提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会使用或整合您的个人信息以及我们的关联方、合作伙伴取得您授权或者依法共享的信息，根据您的使用习惯和常用软件信息等来综合判断您的账号，包括验证身份，预防、发现、调查可能存在的欺诈、网络病毒、网络攻击等安全风险以及违反我们或关联方协议、政策或规则等行为，以保护您、其他用户、我们或关联方的合法权益，并记录一些我们认为有风险的链接(“URL”)。</p>
                <p><span class="pt10 bold">(8）我们可能间接收集的个人信息</span></p>
                <p>为完成身份核验，保障账号安全，争议解决等目的，经您授权后我们可能会从第三方获取您的个人信息。我们会依据法律法规的要求以及与第三方的约定，经您授权后向剑琅联盟的关联方、合作伙伴获得您的有关信息，并对其信息来源的合法性进行确认后使用您的这些信息。</p>
            </div>

            <div class="pt20 bold">二.您可以选择授权我们收集和使用个人信息的场景</div>
            <p class="pt10">为向您提供个性化的服务，您可以选择使用我们提供的拓展功能，我们会在符合法律规定并根据您具体授权的情况下收集并使用如下信息。这类信息将在您选择的具体功能和业务场景中进行收集，如果您不提供这些信息，不会影响您使用剑琅联盟的基本功能。</p>
            <div class="pt10 pl10 bold">1.基于相机授权的拓展功能</div>
            <p><span class="bold">您可以选择开启系统的相机权限，通过使用拍照、录视频，扫码等功能授权剑琅联盟访问您的相机，以便于您通过拍摄照片或录制视频等方式发布内容</span>，如果您需要录制并发布有声视频时，您还需开启麦克风权限。我们会收集您上传发布的上述信息，此项功能您可以在系统权限中关闭，一旦关闭您将可能无法实现扫码功能，或者无法通过拍摄图片、视频等方式进行点评或互动，<span class="bold">但不会影响您享受剑琅联盟产品与/或服务的基本功能。</span></p>
            <div class="pt10 pl10 bold">2.基于相册授权的拓展功能</div>
            <p><span class="bold">您可以选择开启系统的相册权限，通过主动上传图片、视频等方式授权我们访问您的相册，以便于您通过上传照片或上传视频等方式发布内容。</span>我们会收集您选择上传发布的上述信息，此项功能您可以在系统权限中关闭，一旦关闭您将可能无法通过上传图片、视频等方式进行更换头像、发布带图点评等，<span class="bold">但不会影响您享受剑琅联盟产品与/或服务的基本功能。</span></p>
            <div class="pt10 pl10 bold">3.基于麦克风授权的拓展功能</div>
            <p><span class="bold">您可以选择开启系统的麦克风权限，使用语音技术来实现语音搜索等语音交互功能。</span>我们会收集您在使用智能语音技术过程中录入的语音信息用于机器识别、在线交互并满足您的搜索或下单等需求（例如您在剑琅联盟的“按住说话”功能时，我们会根据您的需求进行周边生活服务信息的搜索、展示）。此项功能您可以在系统权限中关闭，一旦关闭您将可能无法实现在线语音交互功能，<span class="bold">但不会影响您享受剑琅联盟产品与/或服务的基本功能。</span></p>
            <div class="pt10 pl10 bold">4.基于通讯录授权的拓展功能</div>
          <p><span class="bold">您可以授权使用我们的服务创建交流与分享功能，并允许剑琅联盟获取您手机或其他第三方社交平台中的通讯录信息和公开信息（头像、昵称等），从而使您及您通讯录中同样授权开通此项功能的联系人，能够在剑琅联盟上分享有关内容（头像、昵称、评价信息等）以实现互动功能。</span>此项功能您可以在系统权限中关闭， 一旦关闭您将可能无法实现基于通讯录的互动功能，<span class="bold">但不会影响您享受剑琅联盟产品与/或服务的基本功能。</span></p>
            <div class="pt10 pl10 bold">5.基于日历授权的拓展功能</div>
          <p><span class="bold">您可以开启系统的日历权限，使用添加日历等功能记录剑琅联盟相关服务的日程， 我们会收集上述信息用于向您展示或定时提醒。</span>此项功能您可以在系统权限中关闭，一旦关闭您将可能无法享受日历记录或提醒功能，<span class="bold">但不会影响您享受剑琅联盟产品与/服务的基本功能。</span></p>

            <div class="pt20 bold">三.征得同意的例外</div>
            <p class="pt10 bold">请您知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</p>
            <p class="bold">1.为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</p>
            <p class="bold">2.为履行法定职责或者法定义务所必需；</p>
            <p class="bold">3.为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
            <p class="bold">4.为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
            <p class="bold">5.依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个 人信息；</p>
            <p class="bold">6.法律法规规定的其他情形。</p>

            <div class="pt20 bold">四.个人信息的使用规则</div>
            <p class="pt10">为满足您的个性化需求，维护、改进我们的产品与/或服务质量，我们会在符合法律规定并根据您具体授权的情况下使用如下信息：</p>
            <p class="bold">1.我们可能会收集您的订单信息、浏览及搜索信息、行为偏好、位置信息等，以及将您在剑琅联盟上使用某项服务中提供的信息与来自其他服务中的信息结合起来，进行综合统计、分析以形成 用户画像，用来向您推荐或展示您可能感兴趣的产品与/或服务信息，或通过系统向您展示个性化的第三方推广信息。包括在 App 页面、微信小程序、微信公众号向您推送消息通知，为您提供智能推荐，通过短信、App 、微信小程序、微信公众号、电子邮件等给您发送推送消息、推广信息或展示商业广告，通过电话进行回访、向您提供信息咨询等服务或邀请您参与服务、 产品或功能有关的客户调研。</p>
            <p>2.我们可能会收集您在参与产品与/或服务调查时主动向我们提供的信息，以及您与我们的关联方、合作伙伴之间互动时提供的相关信息，以便于您追踪订单情况、 发起用户投诉以及我们优化客户服务的质量与流程。</p>
            <p>3.我们可能将业务中收集的个人信息用于统计分析和改进运营，将已经去标识化无法识别您身份且不能复原的信息用于建立数据库并进行商业化利用。例如通过您所在的位置、偏好等进行统计分析，从而改进我们的产品、服务或营销计划；又如为改进我们系统而进行的技术改造、网络维护、故障排除、内部政策与流程制定、生成内部报告等。</p>

            <div class="pt20 bold">三、我们如何使用Cookie和同类技术</div>
            <p class="pt10">1.Cookie的使用：</p>
            <p>为确保网站正常高效运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的设备终端/系统上存储名为Cookie的小数据文件。Cookie会帮助您在后续访问我们网站时调用您的信息，简化您填写个人信息（例如一键登录等）的流程；为您提供安全购物的偏好设置；帮助您优化对广告的选择与互动；保护您的数据安全等。我们不会将Cookie用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除移动设备上保存的所有Cookie，您有权接受或拒绝Cookie。大多数浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie；另外，您也可以清除软件内保存的所有Cookie。但您可能因此无法完全体验我们某些便捷性和安全性的服务功能。</p>
            <p class="pt10">2.网络Beacon和同类技术的使用 ：</p>
            <p>除Cookie外，我们网页上常会包含一些电子图象（称为”单像素"GIF文件或"网络Beacon"）等其他同类技术，它们可以帮助网站计算浏览网页的用户或访问某些Cookie。我们使用网络Beacon的方式有：</p>
            <div>
                <p>(1）我们通过在我们网站上使用网络Beacon，计算用户访问数量，并通过访问Cookie辨认注册用户。</p>
                <p>(2）我们通过得到的Cookie信息，可以在我们网站提供个性化服务。</p>
            </div>
            <div class="pt20 bold">四、我们如何共享、转让、公开披露您的个人信息</div>
            <p class="pt10 bold">1.共享</p>
            <div>
              <p>我们不会与剑琅联盟以外的任何公司、组织和个人共享您的个人信息，<span class="bold">除非存在下列一种或几种情形：</span></p>
              <div class="pl10">
                <p class="bold">1）事先获得您明确的同意或授权。</p>
                <p class="bold">2）您自行提出的。</p>
                <p class="bold">3）基于法定情形下：根据法律法规的规定、诉讼争议解决需要、您与我们签 署的相关协议(包括在线签署的电子协议及平台规则)或法律文件，或行政、司法等有权机关依法提出要求时，我们可能会共享您的个人信息。</p>
                <p>4）与关联方共享：为向您提供一致化服务以及便于您进行统一管理，我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，如果我们共享您的个人敏感信息或者关联方改变个人信息的使用目的，将再次征求您的授权同意。</p>
                <p>5）与合作伙伴分享：您理解并知悉，为了向您提供更完善、优质的产品和服务，我们将授权商业合作伙伴为您提供部分服务。此种情形下，我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。请您注意，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们将对信息数据的输出形式、流转、使用进行安全评估与处理，以保护数据安全。同时，我们会对合作伙伴进行严格的监督与管理，一旦发现其存在违规处理个人信息的行为，将立即停止合作并追究其法律责任。我们的业务合作伙伴包括以下类型：</p>
                <p class="pl10">a. 供应商/服务提供商。仅为实现本政策中声明的目的，我们的某些服务将由业务合作伙伴提供。以保障为您提供的服务顺利完成，我们可能会将您的个人信息共享给上述合作伙伴，包括技术服务、支付服务、金融业务等。其中可能包括您的联络信息、订单信息、支付信息、地址信息等，以保障为您提供的服务顺利完成。例如我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付等。</p>
                <p class="pl10">b.第三方商家。我们必须将您的订单信息与必要交易信息与第三方商家共享，以便其向您提供商品、服务及售后等。</p>
                <p class="pl10">c.其他业务合作伙伴。我们还可能与委托我们进行推广和广告投放的合作伙伴共享信息，但我们仅会向这些合作伙伴提供推广的覆盖面、有效性以及统计类等信息，而不会提供可以识别您身份的个人信息。</p>
                <p>6）基于协议约定：依据您与我们签署的相关协议（包括在线签署的电子协议及平台规则）或法律文件，有必要向第三方共享时；</p>
                <p>7）基于合理商业习惯：例如与第三方共享联合营销活动中的中奖信息，以便第三方能及时向您发放奖品；或者在我们计划与其他公司进行资本市场活动（包括但不限于IPO，债券发行）接受尽职调查时等；</p>
                <p>8）基于学术研究；例如为科研机构开展统计或学术研究之必要；</p>
                <p>9）基于符合法律法规的社会公共利益等。</p>
              </div>
            </div>
            <div class="pt20 bold">
              请您知悉，即使已经取得您的授权同意，我们也仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并尽量对共享内容中的个人信息进行去标识化处理。其中您的联络信息和地址信息属于个人敏感信息，我们已经采取了“默认号码保护”、“地址隐藏”等举措尽全力保护您的个人信息。
            </div>
            <div class="pt20 bold">
              对我们仅为实现本政策中声明的目的与之共享个人信息的公司、组织和个人，我们会与其签署严格的信息保护和保密协定，要求他们遵守协议并采取相关的安全措施来保护您的个人信息。
            </div>
            <p class="pt10 bold">2.转让</p>
            <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
            <div class="pl10">
              <p>1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
              <p>2）随着我们业务的发展，我们及我们的关联方有可能进行合并、收购、资产转让或类似的交易，如涉及个人信息的转让，我们会要求受让您个人信息的公司、组织继续接受本隐私政策的约束，否则,我们将要求该公司、组织重新征求您的授权同意。</p>
            </div>
            <p>除了上述情况，我们不会未经您的明确同意将您的个人信息进行转让。</p>
            <p class="pt10 bold">3.公开披露</p>
            <p>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才可能公开披露您的个人信息：</p>
            <div class="pl10">
              <p>1）根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</p>
              <p>2）根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。</p>
            </div>
            <p class="bold">请注意，您在使用我们服务时自愿发布甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您的交易信息，以及您在评价时选择上传包含个人信息的文字、图片或视频等各种形式的信息。请您在使用我们的服务时更加谨慎地考虑，是否要发布甚至公开分享相关信息。</p>

            <div class="pt10 bold">4.共享、转让、公开披露个人信息时事先征得授权同意的例外</div>
            <div class="pt10">以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</div>
            <div>
                （1）与国家安全、国防安全有关的；
                <br/>（2）与公共安全、公共卫生、重大公共利益有关的；
                <br/>（3）与犯罪侦查、起诉、审判和判决执行等有关的；
                <br/>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
                <br/>（5）其他维护公共利益的情形，例如您的信用评价信息需要被公开/共享；
                <br/>（6）您自行向社会公众公开的个人信息；
                <br/>（7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。根据法律规定，共享、转让、公开披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，我们对此类数据的处理将无需另行向您通知并征得您的同意。
            </div>
            <p class="bold">请注意，您在使用我们服务时自愿发布甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您的交易信息，以及您在评价时选择上传包含个人信息的文字、图片或视频等各种形式的信息。请您在使用我们的服务时更加谨慎地考虑，是否要发布甚至公开分享相关信息。</p>
            <p class="bold">
              根据法律规定，共享、转让、公开披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，我们对此类数据的处理将无需另行向您通知并征得您的同意。</p>

            <div class="pt20 bold">五、我们如何保存和保护您的个人信息</div>
            <div class="pt20 bold">1.个人信息的保存</div>
            <div class="bold">1）保存期限：我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非依据法律法规有强制的留存要求或双方约定，依照其规定。例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；保证我们为您提供服务的安全和质量；您是否同意更长的留存期间；是否存在关于保留期 限的其他特别约定或法律法规规定。 在超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。在您主动注销账号时，我们将根据法律法规的要求进行数据处理。</div>
            <p> 在您主动注销账号时或在超出保留期间后，我们将根据法律法规的要求尽快删除您的个人信息或匿名化处理。</p>
            <div class="bold">&nbsp;&nbsp;（2）保存地域：原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中国境内，但以下情形除外：</div>
            <div class="bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1）法律法规有明确规定的；</div>
            <div class="bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2）单独征得您的授权同意；</div>
            <div class="bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3）您主动发起的跨境预定、下单、交易等个人行为（如购买国际机票、预订国际酒店等）。</div>
            <div class="bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4）在上述情形中，我们会并要求数据接收方按照本隐私政策以及其他相关的安全保密措施来处理个人信息。</div>
            <div>&nbsp;&nbsp;（3）<span class="bold">终止运营：</span>如果发生终止运营等情形，我们将会至少提前30天通知您，并在终止运营后对您的个人信息进行删除或匿名化处理。</div>

            <div class="pt20 bold">2.个人信息的保护措施</div>
            <div>（1）数据安全措施</div>
            <div>
      <span
          class="bold"
      >为保障您的信息安全，我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息，建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。</span>剑琅联盟通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。部署访问控制机制，确保只有授权人员才可访问个人信息；以及举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
            </div>
            <div class="pt20">（2）安全认证</div>
            <div>
                我们已先后通过了公安部信息安全等级保护三级认证、ISO27001信息安全管理体系国际认证等认证资质，并与监管机构、第三方测评机构建立了良好的协调沟通机制，及时抵御并处置各类信息安全威胁，为您的信息安全提供全方位保障。
            </div>
            <div
                class="pt20"
            >
                请您知悉并理解，互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即根据本隐私政策中提供的联系方式联络我们，以便我们采取相应措施。
            </div>
            <div class="pt20">（3）安全事件</div>
            <div>
                在不幸发生个人信息安全事件后，我们会立即成立专项应急小组，启动应急预案，防止安全事件扩大，并按照法律法规的要求及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
            </div>

            <div class="pt20 bold">六、您如何管理您的个人信息</div>
            <div class="pt20">您对您的个人信息享有以下权利：</div>
            <div class="bold">1. 您有权访问、更正、删除您的个人信息，法律法规规定的例外情况除外。</div>
            <div>您可以通过以下方式管理您的信息：</div>
            <div>（1）<span class="bold">账户信息</span>——您可以访问、更正您账户中的个人资料及账号信息（身份认证信息除外）、支付信息、账号绑定信息等，也可以更改您的密码、添加安全信息或关闭您的账户等，您可以通过访问App在设置中执行此类操作。
            </div>
            <div>（2）<span class="bold">地址信息</span>——您可以通过访问剑琅联盟小程序或App 页面上的“设置”—“收货地址” 或“我的地址”中随时添加、更改、删除您的收货地址信息（包括收货人姓名、 性别、收货地址、电话号码等）。</div>
            <div>（3）<span class="bold">搜索浏览信息</span>——您可以在剑琅联盟网页\App中访问或清除您的搜索历史记录、查看和修改兴趣以及管理其他数据。</div>
            <div>（4）<span class="bold">订单信息</span>——您可以通过访问“我的订单”页面查看您的所有已经完成、待付款、待售后、待评价的订单。您可以选择删除已完成的订单信息，但这样可能导致我们无法根据您的购买信息而准确提供相应的售后服务。
            </div>
            <div>（5）<span class="bold">评论信息</span>——您可以通过访问剑琅联盟网页\App页面上的“评价”、“评价中心”访问、更正、清除您的评论内容。</div>
            <div class="pt10 bold">请您知悉，根据法律法规的要求及不同信息的技术条件需要，我们可能无法立即从系统中完全删除您所希望删除的相应信息，在此之前，我们将根据法规要 求对相应信息仅进行存储并采取必要的安全保护措施方面的处理。</div>
            <div class="pt10 bold">如果您无法通过上述链接管理这些个人信息，您可以随时联系我们的客服。我们将在15天内回复您的访问请求。</div>

            <div class="pt20 bold">2.改变您授权同意的范围或撤回授权</div>
            <div>您可以通过在剑琅联盟App中删除信息、更改隐私设置以及在浏览器或操作系统中关闭设备功能等方式改变同意范围或撤回您的授权。</div>
            <div>请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但不会影响此前基于您的授权而开展的个人信息处理。</div>
            <div class="pt20 bold">3.注销账户</div>
            <div>
                您有权注销您的剑琅联盟账户，您注销成功后，我们将根据法律法规的要求尽快删除您的个人信息或作匿名化处理。如果您无法通过上述方式访问、更正或删除您的个人信息以及注销账号，或者如果您认为剑琅联盟存在违反法律的规定收集、使用您个人信息的情形，您可以通过我们的客服与我们取得联系。为了保障安全，我们可能需要您提供相应方式证明您的身份和请求的正当性，
                <strong class="bold">我们将在收到您反馈并验证您的身份后的15天内答复您的请求。</strong>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
            </div>

            <div class="pt20 bold">4.自主管理控制营销信息及定向推送</div>
            <div>（1）拒绝营销——您可以通过回复“TD”退订我们发送给您的营销短信,，如您不希望收到 App或小程序页面上的消息通知，可以在首次安装 App或小程序时拒绝接收消息通知，或者在移动端操作系统中的“通知”中心关掉对应的通知功能。</div>
            <div>（2）拒绝定向推送——您可以在搜索相关服务时拒绝选择“智能排序”的算法推荐模式，而选择“距离优先”、“低价优先”等非定向的推荐模式使用我们的产品\服务。</div>
            <div>（3）个性化推荐——如您不希望使用我们的智能推荐服务，可以自主选择按照距离、 好评、价格等不针对您个人特征的方式进行排序，也可以在推荐信息页面中通过 “不感兴趣”、“不想看”等功能进行精准反馈和实时关闭；还可以在设置中进行自主管理控制。</div>
            <div>（4）个性化广告——如您不希望接收个性化的广告，您可以在设置中自行控制开关，当您关闭后，您看到的广告相关性会降低，但广告不会消失。</div>

            <div class="pt20 bold">七、未成年人的个人信息保护</div>
            <div
                class="pt20 bold"
            >剑琅联盟非常重视对未成年人个人信息的保护。我们的网站和服务主要面向成人。如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。
            </div>
            <div class="pt20 bold">
              如果您是14周岁以下儿童的，在您使用我们的服务前，您和您的监护人应仔细阅读本隐私权政策，确保在取得监护人同意本隐私权政策对您的个人信息的相关处理后，您才可在监护人的指导下使用我们的服务，确保您在使用的服务和进行交易时的安全。
            </div>
            <div class="pt20">如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</div>
            <div class="pt20 bold">八、通知和修订</div>
            <div
                class="pt20"
            >
                为给您提供更好的服务，我们的业务将不时变化，本隐私政策也将随之调整。未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在我们移动端上发出更新版本或以其他方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的隐私政策。在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本政策并受之约束。
            </div>
            <div class="pt20 bold">九、如何联系我们</div>
            <div class="pt10 bold">您可以通过以下方式与我们联系，我们将在 15 天内答复您的请求：</div>
            <div class="pt10">
                如果您对于我们的个人信息处理行为存在任何投诉举报需求，您可以通过剑琅联盟App上提供的联系方式\客服系统与我们联系并作充分描述，我们将在验证您身份的尽快答复您的请求并尽力解决。如果您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼。
            </div>
            <div class="pt10 bold">剑琅联盟客服热线：【  021-63316091  】</div>

            <div class="pt20 bold">十、其他</div>

            <div class="pt10">因本政策以及我们处理您个人信息事宜引起的任何争议，您可诉至上海市黄浦区人民法院。</div>

            <div class="pt10">如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关政府部门进行反映。</div>


          <div class="pt20 bold">十一、附录</div>
            <div>
                <span class="bold">1.个人信息</span>：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
                <span
                    class="bold"
                >本隐私政策中可能涉及到的个人信息包括但不限于：个人基本信息（包括姓名、电话号码、性别、住址、生日等）；个人身份信息（包括身份证、军官证、护照、驾驶证等）；网络身份标识信息（包括系统账号、IP地址、邮箱地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（包括银行账号、交易和消费记录、信贷记录以及虚拟财产信息等）；个人健康生理信息（包括病症、病历、病史等）；联系人信息（包括通讯录、好友列表等）；个人上网记录（包括网站浏览记录、点击记录等）；个人设备信息（包括硬件型号、操作系统类型、唯一设备识别码等描述个人常用设备基本情况的信息）；个人位置信息（包括行踪轨迹、精准定位信息、住宿信息、经纬度等）。</span>
            </div>

            <div>
                <span class="bold">2.个人敏感信息</span>：是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。
                <span
                    class="bold"
                >本隐私政策中可能涉及到的个人敏感信息包括：个人身份信息（包括身份证、军官证、护照、驾驶证等）；个人财产信息（银行账号、交易和消费记录、信贷记录以及虚拟财产信息等）；网络身份识别信息（包括账户名、账户昵称、邮箱地址及与前述有关的密码与密码保护问题和答案）；其他信息（个人电话号码、婚史、宗教信仰、行踪轨迹等）。</span>
            </div>

            <div>
                <span class="bold">3.剑琅联盟</span>：本政策所称的剑琅联盟是指剑琅联盟及其旗下包括但不限于上海集勇信息科技有限公司及现有和\或未来设立的相关关联公司的单称或合称。
            </div>

            <div>
                <span class="bold">4.关联账号</span>：您可以使用相同的手机号码登录剑琅联盟所提供的产品\服务，以便于我们基于关联账号向您提供一致的服务以及您进行统一管理。
            </div>
            <div class="pt20">附件一：</div>
            <div class="title">《用户注销协议》</div>
            <div>在您注销您的账户之前，请充分阅读、理解并同意下列事项：</div>
            <div>
                在此善意地提醒您，您注销剑琅联盟账户的行为，将导致我们终止对您提供本服务，也会给您的售后维权带来诸多不便。注销成功后，我们将删除您的个人信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。您知晓并理解，根据相关法律规定相关交易记录须在剑琅联盟保存3年甚至更长的时间。
            </div>
            <div class="pt20">1.如果您仍执意注销账户，您的账户需同时满足以下条件：</div>
            <div>（1）账户在剑琅联盟系统中无资产、无欠款；</div>
            <div>（2）账户内无未完成的订单、已提供服务但未支付的订单/服务；</div>
            <div>（3）账户无任何纠纷，包括投诉举报或被投诉举报；</div>
            <div>（4）账户为正常使用中的账户且无任何账户被限制的记录；</div>
            <div>（5）账户对应的剑琅联盟支付账户已注销，且已妥善处理了剑琅联盟支付账户下的所有问题。</div>
            <div
                class="pt20"
            >2.在剑琅联盟账户注销期间，如果您的剑琅联盟账户涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，剑琅联盟有权自行终止本剑琅联盟账户的注销而无需另行得到您的同意。
            </div>
            <div class="pt20">3.请您在提交注销申请前，务必解绑其他相关账户，具体可与我们的客服联系。</div>
            <div
                class="pt20"
            >
                4.剑琅联盟账户一旦被注销将不可恢复，请您在操作之前自行备份账户相关的所有信息和数据。注销剑琅联盟账户，您将无法再使用本剑琅联盟账户，也将无法找回您剑琅联盟账户中及与账户相关的任何内容或信息（即使您使用相同的手机号码再次注册并使用剑琅联盟），包括但不限于：
            </div>
            <div>（1）您将无法登录、使用剑琅联盟账户；</div>
            <div>（2）剑琅联盟账户的个人资料和历史信息（包括但不限于用户名、昵称、头像、预定记录等）都将无法找回；</div>
            <div>
                （3）您通过剑琅联盟账号进行登录的剑琅联盟App所有记录将无法找回。您将无法再登录、使用前述服务，您曾获得的优惠券、积分、及其他卡券等视为您自行放弃，将无法继续使用。您理解并同意，剑琅联盟无法协助您重新恢复前述服务。
            </div>
            <div class="pt20">5.注销本剑琅联盟账户并不代表本剑琅联盟账户注销前的账户行为和相关责任得到豁免或减轻。</div>
        </div>
    </div>
</template>
<script>
/* 剑琅联盟app  隐私政策 */
import headerBar from "@/components/headerBar";
import utils from '@/utils/utils';

export default {
    name: 'userAgreement',
    components: {headerBar},
    data() {
        return {
            type: 'H5'
        }
    },

    created() {
        this.init()
    },

    methods: {
        init() {
            let params = utils.url2ParamObject()
            let {type = 'H5'} = params
            this.type = type
        },
        handleBack() {
            this.$router.go(-1)
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/userAgreements/UserAgreement.vue